export const toStringArray = (
	value: (string | number)[] | string | number | null | undefined
): string[] => {
	if (Array.isArray(value)) {
		return value.map(String);
	}
	if (value === undefined || value === null || value === "") {
		return [];
	}
	return [String(value)];
};
